module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctp",
    attrs: {
      "id": "p0022-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_15",
      "id": "sn_15"
    }
  }, [_vm._v("DAY 15")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_15"
    }
  }, [_vm._v("CROUCHING SIN")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" looked with favor on Abel and his offering, but on Cain and his offering he did not look with favor. So Cain was very angry, and his face was downcast.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', [_c('i', [_vm._v("Now Cain said to his brother Abel, “Let’s go out to the field.” While they were in the field, Cain attacked his brother Abel and killed him.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 4:4–5, 8")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0022-04-5"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("W")]), _vm._v("hy did God reject Cain’s offering? Maybe Cain had not offered his best. Perhaps his heart’s attitude had not been right, and his offering was more an act of duty than a gift of gratitude. “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" looks at the heart,” so God knew (1 Samuel 16:7). We can only guess about Cain’s heart, but we can be confident that God is always just, always good, always righteous. The fault could only be Cain’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God had cautioned the angry Cain: “Sin is crouching at your door” (v. 7)—and sin pounced. Angry, perhaps at God, and possibly jealous (God "), _c('i', [_vm._v("had")]), _vm._v(" accepted Abel’s sacrifice), Cain slew his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In this tragedy, we see the ongoing ripple effect of sin. Adam and Eve were estranged from God and from one another. Now two blood brothers were estranged, one the murderer, the other the victim. All were far removed from garden living.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("SIN IS CROUCHING AT THE DOOR. WHAT IS YOUR DEFENSE?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67bf69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter18.vue
// module id = 114
// module chunks = 0